import { render, staticRenderFns } from "./SetupSection.vue?vue&type=template&id=7a789dc5&scoped=true"
import script from "./SetupSection.vue?vue&type=script&lang=js"
export * from "./SetupSection.vue?vue&type=script&lang=js"
import style0 from "./SetupSection.vue?vue&type=style&index=0&id=7a789dc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a789dc5",
  null
  
)

export default component.exports